import React from 'react';
import styled from 'styled-components';
import { H1 } from 'kb-components/core/H1';
import { themes } from 'kb-shared';
import ProfileImageUploadButtonBase from '../../../components/PhotoUpload/ProfilePhoto/ProfileImageUploadButton';
import { useTheme } from 'kb-components/core/theme';
import { useBreakpoints } from 'kb-components/core/useBreakpoints';

const HeaderContainer = styled.div`
  margin-bottom: 50px;
  @media screen and (max-width: ${themes.breakpoints.desktop}) {
    margin-top: 100px;
  }
`;

const ProfileImageUploadButton = styled(ProfileImageUploadButtonBase)`
  display: inline-block;
  margin-right: 20px;
  vertical-align: top;
`;

type Props = {
  name: string;
};

const WelcomeHeader = (props: Props) => {
  const { name } = props;
  const { colors } = useTheme();
  const { isDesktop } = useBreakpoints();
  return (
    <HeaderContainer>
      <ProfileImageUploadButton mode="placeholder" />
      <H1 style={{ color: colors.night, fontSize: isDesktop ? 48 : 36 }}>{`Hello${
        name ? ', ' : ''
      }${name}`}</H1>
    </HeaderContainer>
  );
};

export default WelcomeHeader;
